import { EnrolmentsReplacedEventPayload } from './enrolments-replaced-event-payload';
import { Event } from './event';

export class EnrolmentsReplacedEvent extends Event<EnrolmentsReplacedEventPayload> {}
